module.exports = __webpack_public_path__ + "static/media/wide_-_color_on_transparent__rgb-02.ab9091f7.png";